// extracted by mini-css-extract-plugin
export default {"nonFullscreen":"DGYR6fDp"};